import React from 'react';
import PropTypes from 'prop-types';
import { resolve } from '@cvent/nucleus-dynamic-css';
import ShareBarBase from './ShareBarBase';

export default class TwitterShare extends ShareBarBase {
  static propTypes = {
    customizeWidgetData: PropTypes.object,
    shareBarStyles: PropTypes.object,
    url: PropTypes.string.isRequired,
    additionalURLParams: PropTypes.array
  };
  static defaultProps = {
    additionalURLParams: []
  };

  componentDidMount() {
    super.componentDidMount();
    if (typeof this.window.twttr === 'undefined') {
      // Adding the script to the page to embed Twitter Share Button when this widget gets mounted on the DOM
      const twitterScript = this.window.document.createElement('script');
      twitterScript.src = '//platform.twitter.com/widgets.js';
      twitterScript.async = true;
      twitterScript.id = 'twitter-wjs';
      this.window.document.body.appendChild(twitterScript);
    } else {
      // Re-loading the Share Button when the widget gets re-mounted with existing button in it
      this.window.twttr.widgets.load();
    }
  }

  shouldComponentUpdate() {
    // Not re-rendering the widget when above props gets updated by the user
    // Since, Twitter distorts the button on updating the values attached to the button
    return false;
  }

  componentDidUpdate(prevProps) {
    if (prevProps.customizeWidgetData && this.props.customizeWidgetData &&
      prevProps.customizeWidgetData.displayTwitter !== this.props.customizeWidgetData.displayTwitter) {
      // Re-loading the button when display property is updated by the user
      if (typeof this.window.twttr !== 'undefined') {
        this.window.twttr.widgets.load();
      }
    }
  }

  getTwitterButton = (href) => {
    return {
      __html: `<a href="${href}"
        class="twitter-share-button"
        data-show-count="false">Tweet</a>`
    };
  }

  render() {
    const {
      customizeWidgetData,
      shareBarStyles,
      url,
      additionalURLParams
    } = this.props;

    const updatedURL = this.addQueryParamsToURL(url, additionalURLParams);

    const text = customizeWidgetData.twitterPostText || ' ';  // 'Space' here, is deliberately given.
    const encodedURL = encodeURIComponent(updatedURL);
    const hashtags = customizeWidgetData.twitterEventHashtag || '';
    const href = `https://twitter.com/intent/tweet?text=${encodeURI(text)}&` +
      `url=${encodedURL}&hashtags=${encodeURIComponent(hashtags)}`;

    return (
      <div
        {...resolve(shareBarStyles, 'wrapper', 'twitterContainer')}
        dangerouslySetInnerHTML={this.getTwitterButton(href)} />
    );
  }
}
